import React from 'react';
import { useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { createTeam } from "../teams/TeamSlice";

const TeamCreate = () => {
    const dispatch = useDispatch();
    const { control, handleSubmit } = useForm();

    const onSubmit = (data) => {
            console.log(data)
            dispatch(createTeam(data.teamName));
    };

    return (
        <div className={"max-w-xl mx-auto mt-10 p-4 bg-white rounded shadow relative" }>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                <Controller
                    name="teamName"
                    defaultValue=""
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                        <input
                            {...field}
                            type="text"
                            placeholder="Zadej název týmu"
                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        />
                    )}
                />
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition"
                >
                    Vytvořit tým
                </button>
            </form>
        </div>
    );
};

export default TeamCreate;
